import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { ArrowDownward, Note, Schedule, ShoppingCart } from "@mui/icons-material";
import Overview from "./TabData/Overview";
import Devices from "./TabData/Devices";
import Checkout from "./TabData/Checkout";
import InfraNotes from "./TabData/InfraNotes";
import InternalNotes from "./TabData/InternalNotes";
import OpeningHoursTab from "./TabData/OpeningHoursTab";
import { checkUserDetailsFromCookie, checkUserPermissions } from "../../../api_calls/userManagement";

// to load tab content
function CustomTabPanel(props) {
  const { children, dasboardname, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={false}
      id={`simple-tabpanel-${dasboardname}`}
      aria-labelledby={`simple-tab-${dasboardname}`}
      {...other}
    >
      <Box sx={{ p: 0 }}>{children}</Box>
    </div>
  );
}

// specify mandatory props that custom tab panel will accept
CustomTabPanel.propTypes = {
  children: PropTypes.node,
  dasboardname: PropTypes.number.isRequired,
};

// configure location tabs detail >> label, icon, dashboard and filter
export const fetchInfraTabsInfo = (userType) => {
  const userTypeInfo = checkUserDetailsFromCookie();
  let userDetailObj = {};
  if (userTypeInfo.success === true) {
    userDetailObj = userTypeInfo.user_detail;
  }

  const permissions = checkUserPermissions();
  const permissionScope = permissions?.allowed_access ?? {};

  // Full infrastructure access: Devices, Checkout, Notes tabs visible.
  // Schedule Manager has infra_store_list_can_edit=true but infra_store_monitoring_can_view=false
  // → only Overview and Opening & Quiet Hours visible for that role.
  const hasFullInfraAccess = permissionScope.infra_store_monitoring_can_view === true;

  let infraTabs = [
    {
      label: "Overview",
      unique_key: "general_1",
      dashboard: <Overview />,
      filter_component: <></>,
    },
    {
      label: "Opening & Quiet Hours",
      icon: <Schedule />,
      unique_key: "opening_quiet_hours_1",
      dashboard: <OpeningHoursTab />,
      filter_component: <></>,
    },
  ];

  if (hasFullInfraAccess) {
    infraTabs = [
      ...infraTabs,
      {
        label: "Devices",
        unique_key: "devices_1",
        dashboard: <Devices />,
        filter_component: <></>,
      },
      {
        label: "Checkout",
        icon: <ShoppingCart />,
        unique_key: "checkoutMapping_1",
        dashboard: <Checkout />,
        filter_component: <></>,
      },
      {
        label: "Notes",
        icon: <Note />,
        unique_key: "note_infrastructure_1",
        dashboard: <InfraNotes />,
        filter_component: <></>,
      },
    ];
  }

  if (typeof userDetailObj.user_type !== "undefined" && userDetailObj.user_type === "cyreen") {
    infraTabs = [
      ...infraTabs,
      {
        label: "Internal Notes",
        icon: <Note />,
        unique_key: "internalnote_infrastructure_1",
        dashboard: <InternalNotes />,
        filter_component: <></>,
      },
    ];
  }

  return infraTabs;
};
